<template>
  <div
    class="modal fade"
    id="detay"
    tabindex="-1"
    role="dialog"
    aria-labelledby="detayTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" v-if="programInfo != null">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Kapat"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" id="detayTitle">
            {{ programInfo.birim.birimAdi }} — Başvuru Detayları
          </h4>
        </div>
        <div class="modal-body">
          <h5 class="detail-section-title">Başvuru Koşulları</h5>
          <dl class="detail-list">
            <div class="detail-list__row">
              <dt>Başvuru Başlama</dt>
              <dd>
                <span v-if="isNewApplicationOpen">{{
                  $filters.formatDate(programInfo["baslamaTarihi"])
                }}</span>
                <span v-else>—</span>
              </dd>
            </div>
            <div class="detail-list__row">
              <dt>Başvuru Bitiş</dt>
              <dd>
                <span v-if="isNewApplicationOpen">{{
                  $filters.formatDate(programInfo["bitisTarihi"])
                }}</span>
                <span v-else>—</span>
              </dd>
            </div>
            <div class="detail-list__row">
              <dt>Min. Mezuniyet Notu</dt>
              <dd>
                <span class="grade"
                  >{{ programInfo["minimumMezuniyetNotu100sistem"]
                  }}<small>/100</small></span
                >
                <span class="grade"
                  >{{ programInfo["minimumMezuniyetNotu4sistem"]
                  }}<small>/4</small></span
                >
              </dd>
            </div>
            <div class="detail-list__row" v-if="selectedProgramTypeId === 5371">
              <dt>Min. Y. Lisans Mezuniyet Notu</dt>
              <dd>
                <span class="grade"
                  >{{ programInfo["minYLMezNotu100"] }}<small>/100</small></span
                >
                <span class="grade"
                  >{{ programInfo["minYLMezNotu4"] }}<small>/4</small></span
                >
              </dd>
            </div>
            <div class="detail-list__row">
              <dt>ALES Gerekli mi?</dt>
              <dd>
                <span
                  class="badge-soft badge-soft--yes"
                  v-if="programInfo['alesSartiAranmasin'] === false"
                  >EVET</span
                ><span class="badge-soft badge-soft--no" v-else>HAYIR</span>
              </dd>
            </div>
            <div class="detail-list__row">
              <dt>Minimum ALES Puanı</dt>
              <dd>
                <span
                  class="badge-soft badge-soft--num"
                  v-if="selectedProgramTypeId === 5369"
                  >55</span
                ><span class="badge-soft badge-soft--num" v-else>60</span>
              </dd>
            </div>
            <div class="detail-list__row" v-if="selectedProgramTypeId === 5371">
              <dt>Yabancı Dil Puanı Gerekli mi?</dt>
              <dd><span class="badge-soft badge-soft--yes">EVET</span></dd>
            </div>
            <div class="detail-list__row" v-if="selectedProgramTypeId === 5371">
              <dt>Minimum Yabancı Dil Puanı</dt>
              <dd><span class="badge-soft badge-soft--num">55</span></dd>
            </div>
          </dl>

          <h5 class="detail-section-title">Kontenjan Bilgisi</h5>
          <div class="quota-grid">
            <div class="quota-card">
              <span class="quota-card__value">{{
                programInfo.turkKontenjanAlanIci ?? "—"
              }}</span>
              <span class="quota-card__label">Ulusal Öğrenci</span>
            </div>
            <div class="quota-card">
              <span class="quota-card__value">{{
                programInfo.yabanciKontenjanAlanIci ?? "—"
              }}</span>
              <span class="quota-card__label">Uluslararası Öğrenci</span>
            </div>
            <div class="quota-card">
              <span class="quota-card__value">{{
                programInfo.yedekTurkKontenjanAlanIci ?? "—"
              }}</span>
              <span class="quota-card__label">Ulusal Yedek</span>
            </div>
            <div class="quota-card">
              <span class="quota-card__value">{{
                programInfo.yedekYabanciKontenjanAlanIci ?? "—"
              }}</span>
              <span class="quota-card__label">Uluslararası Yedek</span>
            </div>
          </div>

          <p v-if="programInfo.ekBilgi" class="detail-extra">
            <strong>Ek bilgi:</strong> {{ programInfo.ekBilgi }}
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Kapat
          </button>
          <a
            v-if="announcementUrl"
            :href="announcementUrl"
            target="_blank"
            rel="noopener"
            class="btn btn-primary"
            >Ayrıntılı Bilgi ve Başvuru</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramDetail",
  props: {
    programInfo: {
      required: true,
    },
    isNewApplicationOpen: {
      type: Boolean,
    },
    selectedProgramTypeId: {
      type: Number,
    },
    announcementUrl: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
